export const CONFIG = {
  WS_URL: import.meta.env.VITE_WS_URL,
  API_URL: import.meta.env.VITE_API_URL,
  AGENCY_ID: import.meta.env.VITE_REGENT_AGENCY_ID || 1,
  ENV_MODE: import.meta.env.MODE,
  GOOGLE_KEY: import.meta.env.VITE_GOOGLE_KEY,
};
